import type { SVGProps } from 'react';
const SvgCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M1.944 2.272c-.443.033-.85.24-1.103.56-.207.26-.318.519-.37.86-.02.134-.023.733-.023 4.316 0 2.934.005 4.202.017 4.304.097.788.69 1.337 1.527 1.415.22.02 11.75.022 12.032.002.328-.024.603-.117.835-.283.148-.106.205-.159.3-.278.211-.265.333-.561.376-.912.024-.195.023-8.372-.001-8.568-.097-.788-.689-1.338-1.526-1.416-.205-.019-11.805-.019-12.064 0m.11 1.499c-.09.011-.094.033-.1.649l-.004.556H14.05l-.005-.577c-.005-.645.006-.594-.13-.623-.072-.016-11.737-.02-11.86-.005m-.099 5.557c.004 2.512.007 2.85.029 2.864a.5.5 0 0 0 .1.031c.084.018 11.709.025 11.84.007.056-.008.077-.02.094-.052.018-.035.022-.528.026-2.87l.004-2.828H1.951zm1.82-1.614c-.201.032-.432.21-.53.408-.098.199-.099.45-.002.657.06.13.222.289.365.358l.112.055 2.656.004c2.62.004 2.657.004 2.762-.028a.76.76 0 0 0 .51-.6.76.76 0 0 0-.616-.857c-.122-.02-5.133-.017-5.256.003m-.088 1.834a.82.82 0 0 0-.446.394.745.745 0 0 0 .126.824c.104.11.184.164.313.211l.104.039h1.72c1.594 0 1.726-.002 1.81-.028a.83.83 0 0 0 .48-.444.9.9 0 0 0 .014-.511.74.74 0 0 0-.479-.48C7.234 9.52 7.202 9.52 5.5 9.52c-1.601 0-1.738.003-1.813.028"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCard;
